
/*
* Project: LegalPlace assistant
* File: src/redux/actions/checkout_operations.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/
// TODO: must have a second check here.
import { getEditedOptions, getEditedVariables } from '../../logic/action_counter';
import { getAllOptions } from '../../logic/ovc_converter';
import { loadingPricing, unloadingPricing, setChecking } from './loading';
import { SET_DOCUMENT_ID } from './document_state';
import writeHistory from '../../logic/history';
import { ConditionRuntime } from '../../logic/condition_tree';
import { store } from '../../globals';
import baseLink from "../../baseLink";
import { LpError, unraiseError } from '../../errors/error';
import { lpSetError } from './lperrors';
import lpevents from '../../tracking/lpevents';
import { editedDocument } from './account_settings';
import { setAppState } from './app_state';
import { _lp } from '../../logic/wording';
import lpApp from '../../app/lp_app';
import LpSendInBluekOps from '../../app/ops/sendinblue_notification';
import {saveInstance, validateCoupon, updateInstance} from '../../manager/apiManager'

import { HARCODED_STEP_EXPERT_COMPTABLE_CHECKOUT_META_IDS } from '../../constants/hardcoded_checkout';

const BUILD_CHECKOUT = 'BUILD_CHECKOUT_';
const SEND_INFORMATION = 'SEND_INFORMATION_';
const UPDATE_CSRF = 'UPDATE_CSRF_';
// checkout stage
// promo code
const CK_UPDATE_PROMOTION = 'CK_UPDATE_PROMOTION';
// Packs selections
const CK_SET_PACK = 'CK_SET_PACK';
// Option selection
const CK_TOGGLE_CALL = 'CK_TOGGLE_CALL';
const CK_TOGGLE_LETTER = 'CK_TOGGLE_LETTER';
const CK_UPDATE_NAME = 'CK_UPDATE_NAME';
const CK_UPDATE_ADDRESS = 'CK_UPDATE_ADDRESS';
const CK_UPDATE_CITY = 'CK_UPDATE_CITY';
const CK_UPDATE_ZIP = 'CK_UPDATE_ZIP';
const CK_UPDATE_LETTER_NUMBER = 'CK_UPDATE_LETTER_NUMBER';
// payment
const CK_UPDATE_PAYMENT_METHOD = 'CK_UPDATE_PAYMENT_METHOD';
const CK_UPDATE_C_NUMBER = 'CK_UPDATE_C_NUMBER';
const CK_UPDATE_C_EXPIRATION = 'CK_UPDATE_C_EXPIRATION';
const CK_UPDATE_C_CCV = 'CK_UPDATE_C_CCV';
const CK_UPDATE_DIRECT_NAME = 'CK_UPDATE_DIRECT_NAME';
const CK_UPDATE_IBAN = 'CK_UPDATE_IBAN';
// Payment options
const CK_M_CREDIT_CARD = 0;
const CK_M_PAYPAL = 1;
// checkbox of terms and conditions
const CK_CHECK = 'CK_CHECK';
const CK_UPDATE_REDUCTION = 'CK_UPDATE_REDUCTION';
const CK_LOADING_REDUCTION = 'CK_LOADING_REDUCTION';

const CE_TOGGLE_PACK = 'CE_TOGGLE_PACK';
const PACK_ENTREPRENEUR_HEADER_BTN = 'PACK_ENTREPRENEUR_HEADER_BTN';
const PACK_ENTREPRENEUR_CHOOSE_PACK = 'PACK_ENTREPRENEUR_CHOOSE_PACK'
const PACK_ENTREPRENEUR_ADD_UPSELL = 'PACK_ENTREPRENEUR_ADD_UPSELL'

const IU_NAME = 'IU_NAME';
const IU_ADDRESS = 'IU_ADDRESS';
const IU_CITY = 'IU_CITY';
const IU_ZIP = 'IU_ZIP';
const IU_TVA = 'IU_TVA';
const IU_VIS = 'IU_VIS';


/**
 * @description add the checkout type conditions.
 * @param {Object} val
 */

function ceTogglePack(val, id) {
  const goToExpertComptableStep = (window.location.href).indexOf('paiement') > -1 && HARCODED_STEP_EXPERT_COMPTABLE_CHECKOUT_META_IDS.indexOf(lpApp.contractMetaId) > -1 && id === 3
  const backToExpertComptableStep = (window.location.href).indexOf('checkout') > -1 && HARCODED_STEP_EXPERT_COMPTABLE_CHECKOUT_META_IDS.indexOf(lpApp.contractMetaId) > -1 && id === 3

  if(val === true) {
    // intermediate page and specific case
    // if step 1 && included metaId go to expert-comptable
    if(goToExpertComptableStep) {
      val = false
      writeHistory('expert-comptable', false, false, lpApp.contractUniqid)
    } else {
      writeHistory('checkout', false, false, lpApp.contractUniqid)
    }
  } else {
    if(backToExpertComptableStep) {
      writeHistory('expert-comptable', false, false, lpApp.contractUniqid)
    } else {
      writeHistory('payment', false, false, lpApp.contractUniqid)
    }
  }

  return {
    type: CE_TOGGLE_PACK,
    val,
  };
}

function packEntrepreneur(val) {
  return {
    type: PACK_ENTREPRENEUR_HEADER_BTN,
    val,
  };
}

function packEntrepreneurChoosePack(val) {
  return {
    type: PACK_ENTREPRENEUR_CHOOSE_PACK,
    val,
  };
}

function packEntrepreneurAddUpsell(val) {
  return {
    type: PACK_ENTREPRENEUR_ADD_UPSELL,
    val,
  };
}


function ckCheckCondition(val) {
  return {
    type: CK_CHECK,
    val,
  };
}

// update things here
/**
 * @description update the promo code in the store.
 * @param {String} val
 */
function ckUpdatePromoCode(val) {
  return {
    type: CK_UPDATE_PROMOTION,
    val,
  };
}


/**
 * @description select the pack in the store.
 * @param {number} val
 */
function ckUpdatePack(val) {
  return {
    type: CK_SET_PACK,
    val,
  };
}


/**
 * @description add the call to the store
 * @param {boolean} val
 */
function ckSetCall(val) {
  return {
    type: CK_TOGGLE_CALL,
    val,
  };
}


/**
 * @description set true if the user selected the send-me-letters
 * @param {boolean} val
 */
function ckSetSending(val) {
  return {
    type: CK_TOGGLE_LETTER,
    val,
  };
}


/**
 * @description update the number of letters must be sent
 * @param {number} incr
 */
function ckUpdateLettersNbr(incr) {
  return {
    type: CK_UPDATE_LETTER_NUMBER,
    incr,
  };
}


function ckUpdateName(val) {
  return {
    type: CK_UPDATE_NAME,
    val,
  };
}
/**
 * @description update the city name int he store
 * @param {string} val
 */
function ckUpdateCity(val) {
  return {
    type: CK_UPDATE_CITY,
    val,
  };
}


/**
 * @description update the address of the user
 * @param {string} val
 */
function ckUpdateAddress(val) {
  return {
    type: CK_UPDATE_ADDRESS,
    val,
  };
}


/**
 * @description update zip code
 * @param {number} val
 */
function ckUpdateZip(val) {
  return {
    type: CK_UPDATE_ZIP,
    val,
  };
}
// here we build queries and all

/**
 * @description select the payment type (credit card/ paypal)
 * @param {number} method
 */
function ckPaymentSelect(method) {
  return {
    type: CK_UPDATE_PAYMENT_METHOD,
    method,
  };
}


/**
 * @description update the card number in store
 * @param {number} val
 */
function ckCUpdateCardNumber(val) {
  return {
    type: CK_UPDATE_C_NUMBER,
    val,
  };
}

/**
 * @description update the expiration date.
 * @param {Date} val
 */
function ckCUpdateCardExpiration(val) {
  return {
    type: CK_UPDATE_C_EXPIRATION,
    val,
  };
}


/**
 * @description update ccv
 * @param {number} val
 */
function ckCUpdateCCV(val) {
  return {
    type: CK_UPDATE_C_CCV,
    val,
  };
}

/**
 * @description update direct name
 * @param {string} val
 */
function ckCUpdateDirectName(val){
  return {
      type: CK_UPDATE_DIRECT_NAME,
      val
  }
}

/**
* @description update direct iban
* @param {string} val
*/
function ckCUpdateIban(val){
  return {
      type: CK_UPDATE_IBAN,
      val
  }
}

/**
 * @description uodates the name in invoice section
 * @param {string} val
 */
function invoiceUpdateName(val) {
  return {
    type: IU_NAME,
    val,
  };
}

/**
 * @description updates the address in the invoice
 * @param {string} val
 */
function invoiceUpdateAddress(val) {
  return {
    type: IU_ADDRESS,
    val,
  };
}

/**
 * @description updates the city in invoice section
 * @param {string} val
 */
function invoiceUpdateCity(val) {
  return {
    type: IU_CITY,
    val,
  };
}


/**
 * @description updates ZIP code in invoice section
 * @param {number} val
 */
function invoiceUpdateZip(val) {
  return {
    type: IU_ZIP,
    val,
  };
}


/**
 * @description updates the TVA number
 * @param {string} val
 */
function invoiceUpdateTVA(val) {
  return {
    type: IU_TVA,
    val,
  };
}


/**
 * @description updates the state of visibility of invoice
 * @param {boolean} val
 */
function invoiceUpdateVisibility(val) {
  return {
    type: IU_VIS,
    val,
  };
}

/**
 * @description update the csrf token like received
 * @param {Object} csrf
 */
function updateCSRF(csrf) {
  return {
    type: UPDATE_CSRF,
    csrf,
  };
}

/**
 *
 * @param {string} mail
 * @param {number} totalV total number of variables
 * @param {number} totalO total number of the options selected
 * @param {number} cVersion contract version
 * @param {string} ind individual/commercial buy
 * @param {string} uniqid individual/commercial buy
 * @param {boolean} forceSb individual/commercial buy
 */
function buildPhaseOne(mail = '', totalV, totalO, cVersion, ind = 'ind', uniqid = '', forceSb = false) {
  if (uniqid === '') {
    return {
      email: mail,
      do_not_email: 1,
      nb_total_options: totalO,
      nb_total_vars: totalV,
      nb_chosen_options: lpApp.ops.utils.getEditedOptions(),
      nb_filled_vars: lpApp.ops.utils.getEditedVariables(),
      contract_version: cVersion,
      force_subscription: forceSb,
      client_type: ind,
      app_type: 'react',
      mode: 'expert',
    };
  }

  return {
    email: mail,
    do_not_email: 1,
    nb_total_options: totalO,
    nb_total_vars: totalV,
    nb_chosen_options: getEditedOptions(),
    nb_filled_vars: getEditedVariables(),
    contract_version: cVersion,
    force_subscription: forceSb,
    client_type: ind,
    app_type: 'react',
    mode: 'expert',
    uniqid,
  };
}

function buildPhaseOneSaveFirst(mail, section, json) {
  return {
    email: mail,
    json: JSON.stringify(json),
    mode: 'expert',
    section,
  };
}

/**
 * @description update if the document is saved
 * @param {number} contractId
 * @param {number} section section number
 * @param {Object} json OVC to save
 */
function buildPhaseOneSave(contractId, section, json) {
  return {
    contract_id: contractId,
    do_not_email: 1,
    json: JSON.stringify(json),
    mode: 'expert',
    section,
  };
}

/**
 * @description decide wether the user is individual or a professional
 */
export function isClientPro() {
  const state = store.getState();
  let pro = true;
  const proTest = state.contract.client_type;
  switch (proTest) {
    case 'COND':
      if (state.contract.pro_condition.length === 0) pro = false;
      else {
        const proCond = new ConditionRuntime(state.contract.pro_condition);
        proCond.compileDirect();
        pro = proCond.execute(true);
      }

      break;
    case 'PRO':
    default:
      pro = true;
      break;
  }
  return pro;
}
/**
 * @description send the basic information.
 */
function sendInformation(isCheckout, contractId = null, callback = null) {
  return (dispatch, getState) => {
    // build the query
    const state = getState();
    const ovcc = getAllOptions();
    const body = {
      json: JSON.stringify(ovcc),
      contract_id: !contractId ? state.checkout_operations.contract_id : contractId,
      user_email: store.getState().account_settings.mail,
      contract_version: store.getState().contract.version,
      justSave: true,
      is_two_steps: store.getState().contract.is_two_steps,
      ovc: ovcc
    };
    body[state.checkout_operations.csrf_key] = state.checkout_operations.csrf_value;

    saveInstance(lpApp.contractTitle, body).then((resp) => {
      const parsedObj = resp.data;
      lpevents.trackGTMGAEvent('Inscription email', 'Clic', 'Funnel Contrat standard')

      dispatch(lpSetError(new LpError(0, 0, '')));
      dispatch({ type: SET_DOCUMENT_ID, doc: parsedObj.uniqid });
      if (isCheckout) {
        const event = {};
        event['First proposed price'] = store.getState().checkout_operations.prices.first_price;
        event['Second proposed price'] = store.getState().checkout_operations.prices.second_price;
        event['NB° Chosen options'] = getEditedOptions();
        event['NB° Total options'] = Object.keys(lpApp.references.options).length;
        event['NB° Total variables'] = Object.keys(lpApp.references.variables).length;
        event['NB° Filled variables'] = getEditedVariables();
        event['email_id'] = store.getState().account_settings.mail
        event.Document = store.getState().contract.name;
        event['Document Version'] = store.getState().contract.version;
        event['Nouveau document'] = (typeof (window.contract_id) !== 'undefined' && (window.contract_id === '')) ? 'Oui' : 'Non';
        event['checkoutVersion'] = 'legacy'
        lpevents.register({
          Contract: store.getState().contract.name,
          Email: store.getState().account_settings.mail,
          checkoutVersion: 'legacy'
        });
        lpevents.track('Reached Checkout', event);

        /*
          * Adwords Conversion tracking
          */
        if (event['Nouveau document'] === 'Oui') {
          lpevents.adwordsConversion({
            google_conversion_value: 0.01,
          });
        }
      }

      // On exécute le callback
      if (typeof (callback) === 'function') callback();
    }).catch((err) => {``
      console.error(err);
      lpApp.logs.log(err.name, err.message);
      dispatch(lpSetError(new LpError(0, 1, _lp('Problèmes de connexion, veuillez recharger la page.'))));

      // On exécute le callback
      if (typeof (callback) === 'function') callback();
    });
  };
}

/**
 * @description build the checkout information to the store
 * @param {number} userId
 * @param {number} contractId
 * @param {number} prices
 * @param {number} adminFees
 * @param {string} pricingType
 * @param {Object} csrf
 * @param {Object} cCodes
 * @param {string} desabonnement
 * @param {string} mlLink
 *
 */

function buildCheckout(
  userId,
  contractId,
  contractMetaId,
  prices,
  adminFees,
  pricingType,
  detailsCheckout,
  csrf,
  cCodes,
  desabonnement,
  mlLink,
) {
  return {
    type: BUILD_CHECKOUT,
    user_id: userId,
    contract_id: contractId,
    contract_meta_id: contractMetaId,
    prices,
    admin_fees: adminFees,
    pricing_type: pricingType,
    detailsCheckout,
    csrf,
    c_codes: cCodes,
    desabonnement,
    ml_link: mlLink,
  };
}

/**
 * @description send async document data to the server.
 * @param {boolean} justSave
 * @param {boolean} autosave
 */
export function buildQuery(justSave = false, autosave = false) {
  return (dispatch, getState) => {
    // If it's autosave && document hasn't been edited we stop right here
    if (autosave && !getState().account_settings.edited_doc) {
      dispatch(setChecking(false));
      return;
    }

    const state = getState();
    dispatch(loadingPricing());
    // TODO: can be more sophisticated
    const totalV = Object.keys(lpApp.references.variables).length;
    const totleO = Object.keys(lpApp.references.options).filter(idx => ((lpApp.references.getOption(idx).meta.type === 'radio') || (lpApp.references.getOption(idx).meta.type === 'checkbox'))).length;
    // the test of ind
    const pro = isClientPro();
    // console.log("%cType: " + pro, "color: red");
    // ConditionRuntime(getState().contract.)
    let qb;
    if (justSave) {
      // if(getState)
      if (getState().document_state.unique === '') {
        qb = buildPhaseOneSaveFirst(
          getState().account_settings.mail, getState().contract.currentSection + 1,
          getAllOptions(),
        );
      } else {
        qb = buildPhaseOneSave(
          getState().document_state.unique,
          getState().contract.currentSection + 1,
          getAllOptions(),
        );
      }
    } else {
      qb = buildPhaseOne(
        getState().account_settings.mail,
        totalV,
        totleO,
        getState().contract.version,
        pro ? 'pro' : 'ind',
        state.document_state.unique,
        !!(window.contract_subscription),
      );
      qb.autosave = 1;
    }
    qb.contract_version = getState().contract.version
    qb.ovc = getAllOptions()
    qb.justSave = justSave
    qb.is_two_steps = store.getState().contract.is_two_steps

    if (justSave) {
      dispatch(setChecking(true));
      if (getState().document_state.unique === '') {
        saveInstance(lpApp.contractTitle, qb).then((res) => {
          dispatch(unloadingPricing());
          dispatch(setChecking(false));
          const parsedObj = res.data;
          window.obj = parsedObj;
          lpApp.setContractUniqid(parsedObj.uniqid)
          dispatch({ type: SET_DOCUMENT_ID, doc: parsedObj.uniqid });
          // sending notifs for extarcted variables
          const sdbNotif = new LpSendInBluekOps();
          sdbNotif.sendInBlueNotification(parsedObj, false, () => {
            lpApp.ops.slack.generateMixpanel();
            lpApp.ops.slack.generateSendinBlue('Variable Extraction');
          });
          dispatch({ type: 'UPDATE_C_CODES', c_codes: parsedObj.c_codes });


          dispatch(lpSetError(new LpError(0, 0, '')));
          lpevents.register({ Email: getState().account_settings.mail });
          if (lpApp.isPayed) lpevents.track('Saved Paid document');
          else lpevents.track('Saved document');
          dispatch(editedDocument(false));
          unraiseError('save-mail');
        }).catch((err) => {
          console.error(err)
          // set non connection issue.
          dispatch(setChecking(false));
          dispatch(unloadingPricing());
          dispatch(lpSetError(new LpError(0, 1, _lp('Votre connexion semble lente, veuillez vérifier votre connextion et recharger la page svp.'))));
        });
      } else {
        updateInstance(lpApp.contractTitle, lpApp.contractUniqid, qb).then((response) => {
          const parseObj = response.data;
          window.obj = parseObj;
          dispatch({ type: SET_DOCUMENT_ID, doc: parseObj.uniqid });
          lpApp.setContractUniqid(parseObj.uniqid)
          const sdbNotif = new LpSendInBluekOps();
          sdbNotif.sendInBlueNotification(parseObj, false, () => {
            lpApp.ops.slack.generateMixpanel();
            lpApp.ops.slack.generateSendinBlue('Variable Extraction');
          });


          lpevents.register({ Email: getState().account_settings.mail });


          if (lpApp.isPayed) lpevents.track('Saved Paid document');
          dispatch({ type: 'UPDATE_C_CODES', c_codes: parseObj.c_codes });
          dispatch(lpSetError(new LpError(0, 0, '')));
          dispatch(editedDocument(false));
          unraiseError('save-mail');
          dispatch(setChecking(false));
          dispatch(unloadingPricing());
        }).catch((err) => {
          console.error(err)
          // set non connection issue.
          dispatch(setChecking(false));
          dispatch(unloadingPricing());
          dispatch(lpSetError(new LpError(0, 1, _lp('Votre connexion semble lente, veuillez vérifier votre connextion et recharger la page svp.'))));
        });
      }
    } else {
      const apiCall = getState().document_state.unique === '' ? saveInstance(lpApp.contractTitle, qb) : updateInstance(lpApp.contractTitle, getState().document_state.unique, qb)
      apiCall.then((response) => {
        window.resp = response;
        const parsedObj = response.data;

        dispatch({ type: SET_DOCUMENT_ID, doc: parsedObj.uniqid });
        lpApp.setContractUniqid(parsedObj.uniqid )
        window.obj = parsedObj;
        const sdbNotif = new LpSendInBluekOps();
        sdbNotif.sendInBlueNotification(parsedObj, false, () => {
          lpApp.ops.slack.generateMixpanel();
          lpApp.ops.slack.generateSendinBlue('Variable Extraction');
        });

        if (getState().document_state.state === 'continue' && getState().appstate !== 1){
          writeHistory('payment', true, getState().contract.current_section, getState().document_state.unique);
        }
        else writeHistory('payment', false, getState().contract.current_section, getState().document_state.unique);

        dispatch(lpSetError(new LpError(0, 0, '')));
        dispatch(setAppState(2, true));
        const event = {};
        event['First proposed price'] = store.getState().checkout_operations.prices.first_price;
        event['Second proposed price'] = store.getState().checkout_operations.prices.second_price;
        event['NB° Chosen options'] = getEditedOptions();
        event['NB° Total options'] = Object.keys(lpApp.references.options).length;
        event['NB° Total variables'] = Object.keys(lpApp.references.variables).length;
        event['NB° Filled variables'] = getEditedVariables();
        event['email_id'] = store.getState().account_settings.mail
        event.Document = store.getState().contract.name;
        event['Document Version'] = store.getState().contract.version;
        event['checkoutVersion'] = 'legacy'
        event['Nouveau document'] = (typeof (window.contract_id) !== 'undefined' && (window.contract_id === '')) ? 'Oui' : 'Non';
        lpevents.register({
          Contract: store.getState().contract.name,
          Email: store.getState().account_settings.mail,
          checkoutVersion: 'legacy'
        });
        if (!window.executeEventOnetime){
          lpevents.track('Reached Checkout', event);
          window.executeEventOnetime = 1
        }


        /*
          * Adwords Conversion tracking
          */
        if (event['Nouveau document'] === 'Oui') {
          lpevents.adwordsConversion({
            google_conversion_value: 0.01,
          });
        }
        if (parsedObj.redirect_to) {
          // console.log(_obj);
            window.onbeforeunload = null;
            setTimeout(function () {
              window.location.href = parsedObj.redirect_to;
            }, 100)
            return;
          }
      }).catch((err) => {
        dispatch(unloadingPricing());
        console.log(err);
        lpApp.logs.log(err.name, err.message);
        dispatch(lpSetError(new LpError(0, 1, _lp('Problèmes de connexion, veuillez recharger la page'))));
      });
    }
  };
}

// build the thing
/**
 * @description create the payment object
 * @param {Object} state
 */
function buildDataForPayment(state) {
  const result = {};
  const checkout = state.checkout_operations;
  result.pack = checkout.pack;
  result.contract_id = checkout.contract_id;
  result.payment_method = checkout.payment_method === 0 ? 'stripe' : 'paypal';
  result.card = {
    card_number: checkout.credit_card.number,
    expiration_date: checkout.credit_card.expiration,
    ccv: checkout.credit_card.ccv,
  };
  return result;
}

/**
 * @description update the reduction percentage
 * @param {float} val
 */
function ckReduction(val) {
  return {
    type: CK_UPDATE_REDUCTION,
    reduction: val,
  };
}

function ckSendPromoCode(promo, contractId) {
  return (dispatch) => {
    dispatch({ type: CK_LOADING_REDUCTION, val: true });
    validateCoupon(contractId, promo).then((response) => {
      const obj = response.data
      if (obj.STATUS === 'SUCCESS') {
        if (typeof (obj.redirect_to) === 'string') {
          window.onbeforeunload = null;
          window.location.href = obj.redirect_to;
        }

        dispatch(ckReduction(obj.reduction));
        const globalEvents = {};
        globalEvents['Coupon code'] = promo;
        lpevents.register(globalEvents);
        lpevents.track('Used coupon code', {});
      } else {
        dispatch(ckReduction(obj.MESSAGES[0]));
      }
      dispatch({ type: CK_LOADING_REDUCTION, val: false });
    }).catch(() => {
      dispatch(ckReduction('Une erreur inconnue empêche la vérification de votre code'));
      dispatch({ type: CK_LOADING_REDUCTION, val: false });
    });
  };
}

export {
  BUILD_CHECKOUT,
  SEND_INFORMATION,
  UPDATE_CSRF,
  buildCheckout,
  sendInformation,
  updateCSRF,
  //---------------------------------
  CK_UPDATE_PROMOTION,
  CK_SET_PACK,
  CK_TOGGLE_CALL,
  CK_TOGGLE_LETTER,
  CK_UPDATE_NAME,
  CK_UPDATE_ADDRESS,
  CK_UPDATE_CITY,
  CK_UPDATE_ZIP,
  CK_UPDATE_LETTER_NUMBER,
  //---------------------------------
  CK_UPDATE_PAYMENT_METHOD,
  CK_UPDATE_C_NUMBER,
  CK_UPDATE_C_EXPIRATION,
  CK_UPDATE_C_CCV,
  CK_UPDATE_DIRECT_NAME,
  CK_UPDATE_IBAN,
  CK_M_CREDIT_CARD,
  CK_M_PAYPAL,
  CK_CHECK,
  CK_UPDATE_REDUCTION,
  CK_LOADING_REDUCTION,
  CE_TOGGLE_PACK,
  PACK_ENTREPRENEUR_HEADER_BTN,
  PACK_ENTREPRENEUR_CHOOSE_PACK,
  PACK_ENTREPRENEUR_ADD_UPSELL,

  //---------------------------------
  IU_NAME,
  IU_ADDRESS,
  IU_CITY,
  IU_ZIP,
  IU_TVA,
  IU_VIS,
  //---------------------------------
  invoiceUpdateName,
  invoiceUpdateAddress,
  invoiceUpdateCity,
  invoiceUpdateZip,
  invoiceUpdateTVA,
  invoiceUpdateVisibility,
  //---------------------------------
  ckUpdatePromoCode,
  ckUpdatePack,
  ckSetCall,
  ckSetSending,
  ckUpdateLettersNbr,
  ckUpdateName,
  ckUpdateCity,
  ckUpdateAddress,
  ckUpdateZip,
  ckPaymentSelect,
  ckCUpdateCardNumber,
  ckCUpdateCardExpiration,
  ckCUpdateCCV,
  ckCUpdateDirectName,

  ckCUpdateIban,
  buildDataForPayment,
  ckCheckCondition,
  ckReduction,
  ckSendPromoCode,
  ceTogglePack,
  packEntrepreneur,
  packEntrepreneurChoosePack,
  packEntrepreneurAddUpsell
};



// WEBPACK FOOTER //
// ./src/redux/actions/checkout_operations.js